<mat-sidenav-container class="example-container">
    <mat-sidenav #drawer mode="over">
        <ng-container *ngTemplateOutlet="menuItems"></ng-container>
    </mat-sidenav>

    <mat-toolbar color="primary">
        <div class="mobile-spacer">
            <button mat-button class="menu-button" (click)="drawer.toggle()">
                <mat-icon>menu</mat-icon>
            </button>
        </div>

        <ng-container *ngTemplateOutlet="menuItems"></ng-container>

        <span class="mobile-spacer">&nbsp;</span>
    </mat-toolbar>

    <router-outlet></router-outlet>
</mat-sidenav-container>

<ng-template #menuItems>
    <a mat-button class="home-button" routerLink="/">Jevans' Space</a>

    <a mat-button routerLink="/projects" routerLinkActive="active-link">
        <mat-icon>science</mat-icon>
        Projects
    </a>

    <a mat-button routerLink="/games" routerLinkActive="active-link">
        <mat-icon>sports_esports</mat-icon>
        Games
    </a>

    <a mat-button routerLink="/merch" routerLinkActive="active-link">
        <mat-icon>storefront</mat-icon>
        Merch
    </a>
</ng-template>
